import createIcon from '../../createIcon';

/**
 * @component @name PanToolAlt
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTkuNDggMTQuODJMMTguODUgMTkuMjhDMTguNzEgMjAuMjcgMTcuODYgMjEgMTYuODcgMjFIMTAuNzFDMTAuMTggMjEgOS40MiAyMC43OSA5LjA1IDIwLjQxTDQuNSAxNS42Mkw1LjMzIDE0Ljc4QzUuNTcgMTQuNTQgNS45MSAxNC40MyA2LjI1IDE0LjVMOS41IDE1LjI0VjQuNUM5LjUgMy42NyAxMC4xNyAzIDExIDNDMTEuODMgMyAxMi41IDMuNjcgMTIuNSA0LjVWMTAuNUgxMy40MUMxMy43MiAxMC41IDE0LjAzIDEwLjU3IDE0LjMgMTAuNzFMMTguMzkgMTIuNzVDMTkuMTYgMTMuMTQgMTkuNiAxMy45NyAxOS40OCAxNC44MloiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const PanToolAlt = createIcon('PanToolAlt', [
  [
    'path',
    {
      d: 'M19.48 14.82L18.85 19.28C18.71 20.27 17.86 21 16.87 21H10.71C10.18 21 9.42 20.79 9.05 20.41L4.5 15.62L5.33 14.78C5.57 14.54 5.91 14.43 6.25 14.5L9.5 15.24V4.5C9.5 3.67 10.17 3 11 3C11.83 3 12.5 3.67 12.5 4.5V10.5H13.41C13.72 10.5 14.03 10.57 14.3 10.71L18.39 12.75C19.16 13.14 19.6 13.97 19.48 14.82Z',
      key: '1rm6ph',
    },
  ],
]);

export default PanToolAlt;
